import { http } from '../../../api'

const taskDeckCard = {
  namespaced: true,
  state: {
    task: null
  },
  actions: {
    createTask: ({ commit }, params) => {
      return http.post('/task-deck-card', params).then(res => {
        return res.data
      })
    },
    getTask: ({ commit }, params) => {
      return http.get('/task-deck-card/' + params).then(res => {
        commit('setTask', res.data)
      })
    },
    updateTask: ({ commit }, params) => {
      return http.post('/task-deck-card/' + params.id, params.data).then(res => {
      })
    },
    deleteAnswers: ({ commit }, params) => {
      return http.post('/task-deck-card/delete-answers', params).then(res => {
      })
    }
  },
  mutations: {
    setTask (state, data) {
      state.task = data
    }
  },
  getters: {
    task: state => state.task
  }
}

export default taskDeckCard
